import { Box }   from '@chakra-ui/react';
import React     from 'react'
import { Text }  from '@chakra-ui/react';

interface ILanguageRowProps {
	flagIcon: React.ReactNode;
	languageLabel: string;
}

const LanguageRow = (props: ILanguageRowProps) => {
	const { flagIcon, languageLabel } = props;
	return (
		<Box
			display="flex"
			alignItems="center"
			gap="15px"
			height="50px"
		>
			<Box>
				{flagIcon}
			</Box>
			<Box>
				<Text className='poppins-semibold'>{languageLabel}</Text>
			</Box>
		</Box>
	)
}

export default LanguageRow;